import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, Product, PaginatedProductRetrieveList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined | null | boolean)[];
}

interface IUseProducts {
  searchTerm?: string;
  ordering?: string;
  type?: Product['type'];
}

export default function useProducts({
  searchTerm,
  ordering,
  type,
}: IUseProducts): UseInfiniteQueryResult<AxiosResponse<PaginatedProductRetrieveList>> {
  const fetchProducts = ({
    pageParam = { limit: '20', offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedProductRetrieveList>> => {
    const params = pageParam;

    if (searchTerm) {
      params.search = searchTerm;
    }
    if (type) {
      params.type = type;
    }
    if (ordering) {
      params.ordering = ordering
        .replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
        .concat(',pk')
        .replace('.', '__');
    }

    return client.get(`products/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(['products', searchTerm, ordering, type], fetchProducts, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}
